import React, { useLayoutEffect, useState, useEffect, useRef, useContext, useMemo } from 'react';

import AppContext from '../hooks/AppContext'

import SecondaryPage from '../_template/SecondaryPage'
import Aguardando from '../components/Aguardando'

import { GMap } from 'primereact/gmap';
import { loadGoogleMaps, removeGoogleMaps } from '../utils/GoogleMaps';

import {calcPercent, firebaseTimestampToMoment} from '../utils/utils'

import scmun from '../assets/GeoJson/IBGE-SC-MUN.json'
import municipios from '../assets/GeoJson/IBGE-MUN.json'

const Acompanhamento = (props) => {

  const {setLoading, acompanhamentoSecoes} = useContext(AppContext);  

  const toast = useRef(null);
  const googleMapComponent = useRef(null);    
  const [googleMapsReady, setGoogleMapsReady] = useState(false);    

  const google = window.google;

  let color100 = "#24bf24"
  let color75 = "#ffd334"
  let color50 = "#f59b32"
  let color25 = "#f1622c"
  let colorMaiorQ0 = "#757575"
  let color0 = "#FFFFFF"

  //Desativa o loading para esta tela
  useEffect(() => {    
    setLoading(false)    
  },[]);

  //carreag o google maps
  useEffect(() => {
       
    if(!googleMapsReady){
      loadGoogleMaps(() => {
        setGoogleMapsReady(true);       
      });
    }

    return () => {
      removeGoogleMaps();
    }
   
  },[]);  
  
  //Altera as corres dos municipios com base nas leituras
  useEffect(()=>{

    let mapa = googleMapComponent?.current?.getMap()
    
    if(googleMapsReady){     
      
      mapa?.data?.setStyle( feature => {

        let fColor = '#FFFFFF'

        if(acompanhamentoSecoes){
          let zes=feature?.getProperty("zonasEleitorais")
          
          let lidas = 0
          let total = 0
          zes?.forEach((ze)=>{
            lidas+=ze?.secoesLidas?.length;
            total+=ze?.totalSecoes;
          })
          let percent = calcPercent(lidas,total)

          if(percent==100){
            fColor=color100 //verde
          }else{
            if(percent>=75){
              fColor=color75 //amarelo
            }else{
              if(percent>=50){
                fColor=color50 //laranja
              }else{
                if(percent>=25){
                  fColor=color25 //laranja claro
                }else{
                  if(percent>0){
                    fColor=colorMaiorQ0 // vermelho
                  }
                }
              }
            }
          }
        }
        return {
          strokeColor: '#000000',
          strokeOpacity: 0.9,
          strokeWeight: 1,
          fillColor: fColor,
          fillOpacity: 0.60
        }
      });
    }   
  },[acompanhamentoSecoes,googleMapsReady])
  
  //Armazena os dados das zonas e municipios já processados
  const mapData = useMemo(() =>{

    scmun["features"]?.forEach((item) =>{
      let propriedades = item["properties"]       
      //Carrega nome dos municipios pelo cod de area
      let areaIbge = municipios.find( muni => Number(muni?.municipio?.id) == Number(propriedades["codarea"]))
      if(areaIbge){
        propriedades["nome"]=areaIbge?.municipio?.nome || "municipio"      
        //carrega os dados de secoes e zonas      
        let zes = acompanhamentoSecoes?.zonas?.filter(item =>item?.localidades?.some(localidade => localidade?.nmUe == areaIbge?.municipio?.nome.toLocaleUpperCase()))      
        propriedades["zonasEleitorais"] = zes || []
      }          
    })           
    return scmun;
  },[scmun,acompanhamentoSecoes]);
  
  //carreag o geo Json
  const loadGeoJsonString = (geoJson) => {
    try {        

      let mapa = googleMapComponent?.current?.getMap()

      mapa?.data?.addGeoJson(geoJson,{ idPropertyName: "nome" })        

      //configura os estilos padrão
      mapa?.data?.setStyle({
        strokeColor: '#000000',
        strokeOpacity: 0.9,
        strokeWeight: 1,
        fillColor: color0,
        fillOpacity: 0.50
      });      
      
      zoom();

    } catch (e) {
      alert("Not a GeoJSON file!");
    }  
  }
  
  //Ajusta exibição do mapa com base nos dados
  const zoom = () => {
    
    let mapa = googleMapComponent?.current?.getMap()

    const bounds = new google.maps.LatLngBounds();
  
    mapa?.data?.forEach((feature) => {
      const geometry = feature.getGeometry();
  
      if (geometry) {
        processPoints(geometry, bounds.extend, bounds);
      }
    });
    mapa?.fitBounds(bounds);  
  }

  //função recursiva para processamento dos pontos de geolocalização
  const processPoints = (geometry, callback, thisArg) => {
    if (geometry instanceof google.maps.LatLng) {
      callback.call(thisArg, geometry);
    } else if (geometry instanceof google.maps.Data.Point) {
      callback.call(thisArg, geometry.get());
    } else {
      // @ts-ignore
      geometry.getArray().forEach((g) => {
        processPoints(g, callback, thisArg);
      });
    }
  }

  //eventos de iteração com o mapa
  const initEvents = () => {
    googleMapComponent?.current?.getMap()?.data?.addListener('click', function(event) {
      
      let content = toastContent(event?.feature?.getId(), event?.feature?.getProperty("zonasEleitorais"))
      toast.current.show(content)
      
      //obtem o componente criado para o  gmap                 
      let gm = document.getElementById("gmap")
      //obetem o filho que fica em tela cheia
      let innerGM = gm?.firstChild;
      //obtem o elemento do toast      
      let tst = document.getElementById("toast")     

      //identifica se o google maps está em modo tela cheia
      if(innerGM?.clientHeight == window?.innerHeight){
        //se está em tela cheia adiciona dentro do componente do google maps
        innerGM?.appendChild(tst)        
      }else{             
        //se não está em tela cheia adiciona dentro do container principal
        let mainContainer = document.getElementById("mainContainer")              
        mainContainer?.appendChild(tst)
      }
    });
  }

  //quando o mapa for carregado 
  const onMapReady = () => {       
    //desenha bordas para os municipios
    loadGeoJsonString(mapData)    
    //inicia eventos
    initEvents()

    addEventListener('resize', (event) => {      
      zoom()
    });

    /*window.onresize = function (event) {
      var maxHeight = window.screen.height,
          maxWidth = window.screen.width,
          curHeight = window.innerHeight,
          curWidth = window.innerWidth;
  
      if (maxWidth == curWidth && maxHeight == curHeight) {
          // do something
          console.log("On Resize fullScreen")
      }
    }*/
  }

  //processa conteudo do toast para ser chamado nos eventos
  const toastContent = (titulo, zes)=> {

    let detalhe = (
      <div className="flex-column">
        {          
          zes?.map( ze => {
            return(<div key={ze?.nrZona} className="flex-column">        
              <div className="bloco-title font-bold bloco-secao-resumo-title">{"ZE: "+ze?.nrZona}</div>
              <div className="bloco-secao-resumo">Lidas: {ze?.secoesLidas?.length?.toLocaleString()} de {ze?.totalSecoes?.toLocaleString()}</div>
            </div>)
          })
        }        
      </div>
    )    
    return {life: 5000, severity:'info',  summary: titulo || "titulo", detail: detalhe }
  }

  const leftTitle = () =>{
    if(acompanhamentoSecoes){
      return "Boletins de Urna (BUs) lidos por Município"
    }else{
      return "Aguardando a leitura dos Boletins de Urna"
    }
  }

  const legendaItem = (texto,cor) =>{
    return(
      <div className="w-max inline-flex align-items-baseline ml-2">        
        <div className="mr-2" style={{width:'1em', height:'0.7em', backgroundColor:cor, border:'0.05em solid'}}></div>
        <div>{texto}</div>                  
      </div>
    )
  }
 
  const renderUpdate = () =>{
    if(!acompanhamentoSecoes){
      return null
    }
    return <div className="container-subtitle">
      Seções lidas: {
        acompanhamentoSecoes?.secoesLidas?.toLocaleString() + "/" + 
        acompanhamentoSecoes?.totalSecoes?.toLocaleString() + " em " + 
        firebaseTimestampToMoment(acompanhamentoSecoes?.dataHora)
      }
    </div>
  } 
  
  return (           
    <SecondaryPage titulo={leftTitle()} renderUpdate={renderUpdate()} flexDirection="column" map toast={toast}>
      {googleMapsReady && 
        <GMap id="gmap" ref={googleMapComponent} className= "flex flex-grow-1 map-container" onMapReady={onMapReady}/>                                    
      }
                    
      {googleMapsReady &&
          <div className="inline-flex flex-wrap legenda-mapa ml-3 mr-3">
            <div className="w-max">Legenda:</div>      
            {legendaItem("100%",color100)}
            {legendaItem("75% até 99,9%",color75)}
            {legendaItem("50% até 74,9%",color50)}
            {legendaItem("25% até 49,9%",color25)}
            {legendaItem("0,1% até 24,9%",colorMaiorQ0)}
            {legendaItem("0%",color0)}
          </div>        
      }
    </SecondaryPage>    
);
}


export default Acompanhamento;

